import React from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

import styles from "./Header/Header.module.css";
import DoulaOnBoardingFooter from "./Footer/DoulaOnBoardingFooter";
interface DoulaOnboardingLayoutProps {
	children: React.ReactNode;
}

const DoulaOnboardingLayout: React.FC<DoulaOnboardingLayoutProps> = ({
	children,
}) => {
	const { signOut } = useAuth();
	const navigate = useNavigate();

	const handleSignOut = async () => {
		await signOut();
		navigate("/");
	};

	const headerClasses = [
		styles.header,
		"bg-newTheme-cotton",
	];

	return (
		<div className="min-h-screen bg-gray-50">
			{/* Sticky Glassy Header */}
			<header
				id={styles['header']}
				className={headerClasses.join(" ")}
			>

				<div className="max-w-7xl mx-auto px-4 sm:px-6 xl:px-0">
					<div className="flex justify-between items-center">
						{/* Logo and Dashboard Badge */}
						<div className="flex items-center">
							<div className="flex items-center space-x-2">
								<img
									src="/Gaia_Logo.svg"
									alt="GaiaBirth"
									className={styles.logo}
								/>
							</div>
							<span className="ml-3 px-2 py-1 bg-newTheme-lime text-black text-xs rounded-full font-karla">
								Doula Dashboard
							</span>
						</div>

						{/* Sign Out Button */}
						<div className="flex items-center">
							<Button
								variant="outline"
								size="sm"
								onClick={handleSignOut}
								className={`${styles.portalBtn} border-newTheme-lightGrey text-black hover:bg-gray-50 shadow-btn-shadow hover:text-black`}
							>
								<LogOut className="h-4 w-4 mr-2" />
								Sign Out
							</Button>
						</div>
					</div>
				</div>
			</header>

			{/* Main Content */}
			<main className="mt-6">
				<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
					{children}
				</div>
			</main>

			<DoulaOnBoardingFooter />
		</div>
	);
};

export default DoulaOnboardingLayout;
